<template>
   <dashboard-layout>
      <v-container fluid class="down-top-padding py-0">
         <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>

         <v-card class="cpd-ext-card mb-5">
            <v-toolbar flat color="white">
               <v-toolbar-title>External Organizer Event / Program Registrations</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
               <v-spacer></v-spacer>
               <v-btn color="primary" dark @click="openEmailDialog">
                  Email Event / Program Registration Form
               </v-btn>
            </v-toolbar>
            <v-data-table
               :headers="headers"
               :items="newItems"
               :loading="loading"
               class="border cpd-ext-table"
               item-key="id"
               no-data-text="No data available"
               :footer-props="footerProps"
            >
               <template v-slot:[`item.no`]="{ index }">{{ index + 1 }}</template>
               <template v-slot:[`item.epdate`]="{ item }">{{ formatDate(item.epdate) }}</template>
               <template v-slot:[`item.submitdate`]="{ item }">{{ formatDateTime(item.submitdate) }}</template>
               <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small color="primary" @click="openEditDialog(item)">
                     <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="error" @click="deleteItem(item)">
                     <v-icon small>mdi-delete</v-icon>
                  </v-btn>
               </template>
            </v-data-table>
         </v-card>

         <v-card class="cpd-ext-card mb-5">
            <v-toolbar flat color="white">
               <v-toolbar-title>External Organizer Event / Program Registrations - Pending Payment</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <v-data-table
               :headers="headers"
               :items="pendingPaymentItems"
               :loading="loading"
               class="border cpd-ext-table"
               item-key="id"
               no-data-text="No data available"
               :footer-props="footerProps"
            >
               <template v-slot:[`item.no`]="{ index }">{{ index + 1 }}</template>
               <template v-slot:[`item.epdate`]="{ item }">{{ formatDate(item.epdate) }}</template>
               <template v-slot:[`item.submitdate`]="{ item }">{{ formatDateTime(item.submitdate) }}</template>
               <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small color="primary" @click="openEditDialog(item)">
                     <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="error" @click="deleteItem(item)">
                     <v-icon small>mdi-delete</v-icon>
                  </v-btn>
               </template>
            </v-data-table>
         </v-card>

         <v-card class="cpd-ext-card">
            <v-toolbar flat color="white">
               <v-toolbar-title>External Organizer Event / Program Registrations - Completed</v-toolbar-title>
               <v-divider class="mx-4" inset vertical></v-divider>
            </v-toolbar>
            <v-data-table
               :headers="headers"
               :items="completedItems"
               :loading="loading"
               class="border cpd-ext-table"
               item-key="id"
               no-data-text="No data available"
               :footer-props="footerProps"
            >
               <template v-slot:[`item.no`]="{ index }">{{ index + 1 }}</template>
               <template v-slot:[`item.epdate`]="{ item }">{{ formatDate(item.epdate) }}</template>
               <template v-slot:[`item.submitdate`]="{ item }">{{ formatDateTime(item.submitdate) }}</template>
               <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small color="primary" @click="openEditDialog(item)">
                     <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon small color="error" @click="deleteItem(item)">
                     <v-icon small>mdi-delete</v-icon>
                  </v-btn>
               </template>
            </v-data-table>
         </v-card>

         <v-dialog v-model="emailDialog" max-width="520px">
            <v-card>
               <v-card-title>Email Registration Form</v-card-title>
               <v-card-text>
                  <v-text-field
                     v-model="email"
                     label="Organizer Email"
                     type="email"
                     :error-messages="emailError"
                  ></v-text-field>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="emailDialog = false">Cancel</v-btn>
                  <v-btn color="primary" dark :loading="saving" @click="sendEmail">Send Email</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-dialog v-model="editDialog" max-width="720px">
            <v-card>
               <v-card-title>Update External Organizer Registration</v-card-title>
               <v-card-text>
                  <v-row>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="edited.eoorgname" label="Organizer Name"></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="edited.eocontactno" label="Organizer Contact No."></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="edited.eoemail" label="Organizer Email"></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="edited.eoname" label="EP Name"></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="edited.epdate" label="EP Date" type="date"></v-text-field>
                     </v-col>
                     <v-col cols="12" md="6">
                        <v-text-field v-model="edited.epduration" label="EP Duration"></v-text-field>
                     </v-col>
                  </v-row>
               </v-card-text>
               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="editDialog = false">Cancel</v-btn>
                  <v-btn color="primary" dark :loading="saving" @click="saveEdit">Save</v-btn>
               </v-card-actions>
            </v-card>
         </v-dialog>

         <v-snackbar v-model="snackbar" :color="snackbarColor">{{ snackbarText }}</v-snackbar>
      </v-container>
   </dashboard-layout>
</template>

<script>
import BaseBreadcrumb from '@/components/BaseBreadcrumb.vue'
import DashboardLayout from '@/Layouts/DashboardLayout.vue'
const axios = require('axios')

export default {
   name: 'MOAExtOrgEvtProgs',
   components: { DashboardLayout, BaseBreadcrumb },
   data() {
      return {
         page: { title: 'CPD Management' },
         breadcrumbs: [
            { text: 'Dashboard', disabled: false, to: '/dashboard' },
            { text: 'CPD Management', disabled: false, to: '/admin/cpd' },
            { text: 'External Organizers', disabled: true },
         ],
         loading: false,
         saving: false,
         emailDialog: false,
         editDialog: false,
         email: '',
         emailError: '',
         edited: {},
         newItems: [],
         pendingPaymentItems: [],
         completedItems: [],
         snackbar: false,
         snackbarColor: 'info',
         snackbarText: '',
         footerProps: {
            'items-per-page-options': [10, 25, 50],
         },
         headers: [
            { text: 'No.', value: 'no', sortable: false, width: 70 },
            { text: 'Organizer Name', value: 'eoorgname' },
            { text: 'Organizer Contact No.', value: 'eocontactno' },
            { text: 'Organizer Email', value: 'eoemail' },
            { text: 'EP Name', value: 'eoname' },
            { text: 'EP Date', value: 'epdate' },
            { text: 'EP Duration', value: 'epduration' },
            { text: 'Secure Code', value: 'eoseccode' },
            { text: 'Submit Date', value: 'submitdate' },
            { text: 'Actions', value: 'actions', sortable: false, width: 110 },
         ],
      }
   },
   mounted() {
      this.loadAll()
   },
   methods: {
      loadAll() {
         this.loading = true
         Promise.all([
            axios.get('/admin/cpd-ext-orgs/list-new'),
            axios.get('/admin/cpd-ext-orgs/list-pendingpayment'),
            axios.get('/admin/cpd-ext-orgs/list-completed'),
         ]).then(([newResp, pendingResp, completedResp]) => {
            this.newItems = this.responseItems(newResp)
            this.pendingPaymentItems = this.responseItems(pendingResp)
            this.completedItems = this.responseItems(completedResp)
         }).finally(() => {
            this.loading = false
         })
      },
      responseItems(resp) {
         return resp.data && resp.data.status === 'OK' ? (resp.data.data || []) : []
      },
      openEmailDialog() {
         this.email = ''
         this.emailError = ''
         this.emailDialog = true
      },
      sendEmail() {
         this.emailError = ''
         if (!this.email || !/.+@.+\..+/.test(this.email)) {
            this.emailError = 'Valid organizer email is required.'
            return
         }
         this.saving = true
         const data = new FormData()
         data.append('email', this.email)
         axios.post('/admin/ext-org-form/sendemail', data)
            .then((resp) => {
               this.notify(resp.data && resp.data.status === 'OK', 'Registration form email sent.')
               this.emailDialog = false
               this.loadAll()
            })
            .catch((error) => this.notify(false, this.errorText(error)))
            .finally(() => {
               this.saving = false
            })
      },
      openEditDialog(item) {
         this.edited = Object.assign({}, item, {
            epdate: this.dateInput(item.epdate),
         })
         this.editDialog = true
      },
      saveEdit() {
         this.saving = true
         const data = new FormData()
         ;['id', 'eoorgname', 'eoemail', 'eocontactno', 'eoname', 'epdate', 'epduration'].forEach((field) => {
            data.append(field, this.edited[field] || 'null')
         })
         axios.post('/admin/ext-org-form/update', data)
            .then((resp) => {
               this.notify(resp.data && resp.data.status === 'OK', 'External organizer registration updated.')
               this.editDialog = false
               this.loadAll()
            })
            .catch((error) => this.notify(false, this.errorText(error)))
            .finally(() => {
               this.saving = false
            })
      },
      deleteItem(item) {
         if (!window.confirm('Delete this external organizer registration?')) {
            return
         }
         const data = new FormData()
         data.append('id', item.id)
         axios.post('/admin/ext-org-form/delete', data)
            .then((resp) => {
               this.notify(resp.data && resp.data.status === 'OK', 'External organizer registration deleted.')
               this.loadAll()
            })
            .catch((error) => this.notify(false, this.errorText(error)))
      },
      notify(ok, fallback) {
         this.snackbarColor = ok ? 'success' : 'error'
         this.snackbarText = fallback
         this.snackbar = true
      },
      errorText(error) {
         return error && error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Unable to complete request.'
      },
      dateInput(value) {
         if (!value) return ''
         return String(value).substring(0, 10)
         if (!value) return '-'
         return this.$moment(value).format('YYYY-MM-DD')
      },
      formatDate(value) {
         if (!value) return '-'
         return this.$moment(value).format('YYYY-MM-DD')
      },
      formatDateTime(value) {
         if (!value) return '-'
         return this.$moment(value).format('YYYY-MM-DD HH:mm:ss')
      },
   },
}
</script>

<style scoped>
.cpd-ext-card {
   overflow: hidden;
}

.cpd-ext-card ::v-deep .v-toolbar__title {
   font-size: 18px;
   font-weight: 500;
}

.cpd-ext-table ::v-deep .v-data-table__wrapper {
   overflow-x: auto;
}

.cpd-ext-table ::v-deep table {
   min-width: 980px;
}

.cpd-ext-table ::v-deep .v-data-table-header th {
   font-size: 11px;
   font-weight: 600;
   color: #263238 !important;
   vertical-align: middle;
   line-height: 1.25;
}

.cpd-ext-table ::v-deep tbody td {
   font-size: 12px;
   line-height: 1.35;
   vertical-align: middle;
}
</style>
